export default Object.freeze({

    //These the keys used in routing to validate that unlicensed features are enabled.
    //They need to match the property names in the nested Feature object in GlobalSettings.
    Projects: 'ProjectsEnabled',
    AssetTypes: 'AssetTypesEnabled',
    Leads: 'LeadsEnabled',
    Unit: 'UnitEnabled'

});